import { useRouter } from 'next/navigation';
import { IValidationToastNotification, Routes } from '../../common';
import { getAppendingNumericIdFromUrl } from '../../utils';
import { OrderViewTabs } from '../sales/sales-common/enums';
import { getErrorMessageFromNextError } from './NextErrorMessageMapper';
import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

/**
 * Catch error from server, present to user nicley wrapped.
 * Supports types of NextFunctionalError
 */
export interface INextErrorNotificationProps extends IValidationToastNotification {
  errorCode: number;
  orderId?: string;
  hideLink?: boolean;
}

export const NextErrorNotification = ({
  errorCode,
  hideLink,
  orderId,
  severityLevel = TMessageBarSeverity.WARNING,
  onClose,
}: INextErrorNotificationProps) => {
  const getOrderId = () => {
    if (hideLink) return null;
    return orderId || getAppendingNumericIdFromUrl('');
  };
  const router = useRouter();

  const redirectToEvents = async () => {
    const route = Routes.getViewPage(getOrderId());
    router.push(`${route}?tab=${OrderViewTabs.EVENTS}`);
  };

  return (
    <MessageBar
      severity={severityLevel}
      onClose={onClose}
      dismissible
      className="w-full max-w-1/3 border-none rounded-lg gap-6 border-0 py-8 [&_.tw-dismiss-button]:-top-4"
    >
      <h4 className="text-lg/[175%]">Handling feilet</h4>
      <p className="text-base/[175%] font-semibold">{getErrorMessageFromNextError(errorCode)}</p>
      {getOrderId() && (
        <>
          <span className="text-base/[175%] font-semibold">Ytterligere informasjon finnes her: </span>
          <a className="text-base/[175%] font-semibold underline cursor-pointer" onClick={() => redirectToEvents()}>
            Hendelser
          </a>
        </>
      )}
    </MessageBar>
  );
};
